module.exports = __webpack_public_path__ + "files/347d93f869ce1b389438be74b0fb9911.png";